import React from 'react';
import FoodItem from '../FoodItem/FoodItem';

const FoodDisplay = ({ category, food_list }) => {
  if (!food_list || food_list.length === 0) {
    return <div>No food items available.</div>;
  }

  return (
    <section style={{ backgroundColor: '#0a0a0c', width: '100%', padding: '6rem 0' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 2rem' }} id='food-display'>
        <div className="tf-grid" style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', 
          gap: '3rem',
          justifyContent: 'center' 
        }}>
          {food_list.map((item, index) => {
            if (category === "All" || category === item.category) {
              return (
                <FoodItem 
                  key={index} 
                  id={item._id} 
                  name={item.name} 
                  description={item.description} 
                  price={item.price} 
                  image={item.image}
                  date={item.date}
                  category={item.category}
                />
              );
            }
            return null;
          })}
        </div>
      </div>
    </section>
  );
};

export default FoodDisplay;